import { MainState } from ".."

export const managerSelector = (s: MainState) => s.manager
export const navigationSelector = (s: MainState) => s.navigation
export const summarySelector = (s: MainState) => s.summary
export const externSelector = (s: MainState) => s.extern
export const calculationSelector = (s: MainState) => s.calculation
export const transactionsSelector = (s: MainState) => s.transactions
